import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';


/**
 * Firebase configuration for mutual. The current configuration is initialized in this js file to be used as a Singleton.
 * The reason being since when logging in with a phone there are separate components that use firebase.
 * @type {{storageBucket: string, apiKey: string, messagingSenderId: string, appId: string, projectId: string, measurementId: string, databaseURL: string, authDomain: string}}
 */
const firebaseConfig = {
    apiKey: 'AIzaSyCpzgDpcJcppIFytyEzFkfpWembedDJoAU',
    authDomain: 'mutual-37081.firebaseapp.com',
    databaseURL: 'https://mutual-37081.firebaseio.com',
    projectId: 'mutual-37081',
    storageBucket: 'mutual-37081.appspot.com',
    messagingSenderId: '740259366867',
    appId: '1:740259366867:web:f72ca548be25c8a8c75126',
    measurementId: 'G-ZR5WXSF5VT'
};

firebase.initializeApp(firebaseConfig);

export default firebase
